import UpdateTarifaPage from './UpdateTarifaPage';

export default UpdateTarifaPage;
